"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactLoaderSpinner = _interopRequireDefault(require("react-loader-spinner"));
var _utils = require("../../utils");
var _styled = require("../base/styled");
var _styled2 = require("./styled");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var getContactTagsFiltered = function getContactTagsFiltered() {
  var contactTags = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var tag = arguments.length > 1 ? arguments[1] : undefined;
  return contactTags.filter(function (contactTag) {
    return contactTag.id !== tag;
  });
};
var getSelectedContactTagName = function getSelectedContactTagName() {
  var _contactTags$find;
  var contactTags = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var tag = arguments.length > 1 ? arguments[1] : undefined;
  return ((_contactTags$find = contactTags.find(function (contactTag) {
    return contactTag.id === tag;
  })) === null || _contactTags$find === void 0 ? void 0 : _contactTags$find.contacted) || 'Contact Candidate';
};
var ContactTags = function ContactTags(_ref) {
  var contactTags = _ref.contactTags,
    applicantContactTag = _ref.applicantContactTag,
    isSaving = _ref.isSaving,
    onShowContactTags = _ref.onShowContactTags,
    show = _ref.show,
    onSelect = _ref.onSelect,
    applicantId = _ref.applicantId;
  return /*#__PURE__*/_react.default.createElement(_styled2.Container, null, /*#__PURE__*/_react.default.createElement(_styled2.ContactTag, {
    onClick: function onClick() {
      return onShowContactTags(!show);
    }
  }, /*#__PURE__*/_react.default.createElement(_styled2.ContactTagDescriptionContainer, null, isSaving === applicantId ? /*#__PURE__*/_react.default.createElement(_reactLoaderSpinner.default, {
    type: "TailSpin",
    color: "white",
    height: 24,
    width: 24
  }) : /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_styled.Row, {
    center: true,
    $bsStyle: {
      marginLeft: '40px'
    }
  }, getSelectedContactTagName(contactTags, applicantContactTag)), /*#__PURE__*/_react.default.createElement(_styled2.ArrowContainer, null, /*#__PURE__*/_react.default.createElement(_styled2.ArrowDown, {
    $visibility: show
  }))))), /*#__PURE__*/_react.default.createElement(_styled2.TagsSelectorContainer, {
    $visibility: show
  }, /*#__PURE__*/_react.default.createElement(_styled2.TagsSelector, {
    $visibility: show
  }, getContactTagsFiltered(contactTags, applicantContactTag).map(function (tag, index) {
    return /*#__PURE__*/_react.default.createElement(_styled2.ContactTagSelector, {
      $visibility: show,
      delay: index + 1,
      key: tag.id,
      onClick: function onClick() {
        return onSelect(tag.id);
      }
    }, tag.name);
  }))));
};
ContactTags.propTypes = {
  onSelect: _propTypes.default.func.isRequired,
  onShowContactTags: _propTypes.default.func.isRequired,
  show: _propTypes.default.bool.isRequired,
  isSaving: _propTypes.default.bool.isRequired,
  applicantId: _propTypes.default.number,
  applicantContactTag: _propTypes.default.number,
  contactTags: _utils.contactTagsPropTypes
};
ContactTags.defaultProps = {
  applicantId: undefined,
  applicantContactTag: undefined,
  contactTags: []
};
var _default = ContactTags;
exports.default = _default;